module.exports = __webpack_public_path__ + "img/5.531f3f3b.jpg";